module.exports = __webpack_public_path__ + "static/media/gtline.44a8873c.jpg";